import {} from 'viem';
import { Emitter } from '../createEmitter.js';
import {} from '../createStorage.js';
import {} from '../types/utils.js';
export function createConnector(createConnectorFn) {
    return createConnectorFn;
}
//# sourceMappingURL=createConnector.js.map